import { memo } from 'react';

import PropTypes from 'prop-types';

import AppButton from '@components/common/AppButton';
import AppDialog from '@components/common/AppDialog';
import AppTypography from '@components/common/AppTypography';

const ConfirmDialog = memo(function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title = 'Confirm',
  description = 'Are you sure you want to continue?',
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  confirmColor = 'primary',
  loading = false,
}) {
  return (
    <AppDialog
      open={open}
      onClose={loading ? undefined : onClose}
      title={title}
      showCloseButton={!loading}
      actions={
        <>
          <AppButton variant="outlined" onClick={onClose} disabled={loading}>
            {cancelLabel}
          </AppButton>
          <AppButton color={confirmColor} onClick={onConfirm} loading={loading}>
            {confirmLabel}
          </AppButton>
        </>
      }
    >
      <AppTypography variant="body2" color="text.secondary">
        {description}
      </AppTypography>
    </AppDialog>
  );
});

ConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  title: PropTypes.string,
  description: PropTypes.node,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  confirmColor: PropTypes.string,
  loading: PropTypes.bool,
};

export default ConfirmDialog;
